import { Component, OnInit, ViewChild, Input, EventEmitter } from "@angular/core";
import { MatDialogConfig } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from '@angular/material/sort';


@Component({
  selector: "master-table-profile",
  templateUrl: "./table-profile.component.html",
})
export class MasterTableProfile implements OnInit {
  profiles: any;
  filterAutoComplete: Array<any>;
  usersComplete: any;
  dialogConfig: any;

  @ViewChild('sort', {static: false}) sort: MatSort;
  @Input() displayColumns: Array<string>;
  @Input() dataProfiles: Array<any>
  @Input() filterProfile: EventEmitter<any>;

  profileFilter: any;

  ngOnInit() {
    this.dialogConfig= new MatDialogConfig();

    this.dialogConfig.disableClose = true;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.hasBackdrop = true;
    this.dialogConfig.height = '90vh';
    this.dialogConfig.width = '92vw';
    this.dialogConfig.maxWidth = '100vw';
    this.getProfiles()

    this.profiles.sort = this.sort;
  }
  ngAfterViewInit (){
    this.profiles.sort = this.sort;
  }

  getProfiles(){
    let dataProfile = this.dataProfiles;
    dataProfile.sort((a, b) => {
      if (a.profile === null) {a.profile = ''};
      if (b.profile === null) {b.profile = ''};
      return (a.profile.toLowerCase() > b.profile.toLowerCase() ?  1 : -1);
    })
    this.profiles = new MatTableDataSource(dataProfile)
    this.profiles.sort = this.sort;
  }
}
